import { updateUserLanguage } from "@/services/rest/common-service";
import { useMutation } from "@tanstack/react-query";

export function useUpdateUserLanguage() {
  return useMutation({
    mutationFn: updateUserLanguage,
    retry: 3,
    retryDelay: attemptIndex =>
      Math.min(1000 * 2 ** attemptIndex, 5000),
    onError: () => {
      console.warn("Save language failed");
    },
  });
}
